import React from "react";
import { BiErrorCircle } from "react-icons/bi";




const ErrorAlter = () => {
  return (
    <div className="sm:min-w-screen md:max-w-[400px] mx-auto min-h-screen flex flex-col justify-center items-center bg-white py-4">
    <div className="flex flex-col items-center">
      {/* <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-green-500 mb-4" /> */}
      <BiErrorCircle size="4rem" className="text-red-500 mb-8" />
      {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover mb-4" /> */}
      <span className="text-2xl font-bold text-center text-[#535353] mt-8 mb-8">고객정보 오류!</span>
    </div>
  </div>
  );
};

export default ErrorAlter;
